module.exports = __webpack_public_path__ + "static/media/paso-3.6da1e53b.png";